import { render } from "./PaymentDays.vue?vue&type=template&id=71c7d1a6&scoped=true"
import script from "./PaymentDays.vue?vue&type=script&lang=js"
export * from "./PaymentDays.vue?vue&type=script&lang=js"

import "./PaymentDays.vue?vue&type=style&index=0&id=71c7d1a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c7d1a6"]])

export default __exports__